import { getSimpleRequisites } from '@/core/utils/helpers';
export function formatInvoiceNumberAndDate({ invoiceNumber, invoiceDate }) {
    // TODO: to delete comment later.
    // return `${invoiceNumber} ${t('dated.label')} ${formatDate(new Date(invoiceDate), 'P')}`;
    return getSimpleRequisites(invoiceNumber, invoiceDate, 'P');
}
